// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* =========================
   CONFIGURACIÓN GENERAL
========================= */

* {

    margin: 0;

    padding: 0;

    box-sizing: border-box;

}


body {

    background: #f4f6f9;

    font-family: Arial, sans-serif;

    overflow-x: hidden;

}


/* =========================
   SIDEBAR
========================= */

.sidebar {

    width: 280px;

    height: 100vh;

    min-height: 100vh;

    max-height: 100vh;

    background: linear-gradient(
        180deg,
        #1f2937,
        #111827
    );

    position: fixed;

    top: 0;

    left: 0;

    z-index: 1050;

    color: white;

    padding: 20px;

    /* =========================
       SCROLL VERTICAL
    ========================== */

    overflow-y: auto;

    overflow-x: hidden;

    /* =========================
       SCROLLBAR
    ========================== */

    scrollbar-width: thin;

    scrollbar-color:
        #4b5563
        #111827;

    transition: all 0.3s ease;

}


/* =========================
   SCROLLBAR CHROME / EDGE
========================= */

.sidebar::-webkit-scrollbar {

    width: 7px;

}


.sidebar::-webkit-scrollbar-track {

    background: #111827;

}


.sidebar::-webkit-scrollbar-thumb {

    background: #4b5563;

    border-radius: 10px;

}


.sidebar::-webkit-scrollbar-thumb:hover {

    background: #6b7280;

}


/* =========================
   LOGO
========================= */

.logo {

    text-align: center;

    padding: 15px;

    border-bottom: 1px solid #374151;

    margin-bottom: 15px;

}


.logo i {

    font-size: 42px;

    color: #38bdf8;

}


.logo h4 {

    margin-top: 8px;

    font-weight: bold;

}


.logo small {

    color: #9ca3af;

}


/* =========================
   TITULOS MENU
========================= */

.menu-title {

    font-size: 11px;

    color: #9ca3af;

    margin: 20px 10px 10px;

    text-transform: uppercase;

    font-weight: bold;

}


/* =========================
   LINKS SIDEBAR
========================= */

.sidebar .nav-link {

    color: #d1d5db;

    padding: 12px 15px;

    margin-bottom: 5px;

    border-radius: 8px;

    transition: all 0.3s;

    white-space: nowrap;

    cursor: pointer;

}


.sidebar .nav-link:hover {

    background: #374151;

    color: white;

}


.sidebar .nav-link.active {

    background: #0ea5e9;

    color: white;

}


.sidebar .nav-link i {

    margin-right: 10px;

}


/* =========================
   SUBMENUS
========================= */

.submenu {

    display: none;

    background: rgba(255,255,255,0.05);

    border-radius: 8px;

    margin-bottom: 8px;

    overflow: hidden;

}


.submenu.show {

    display: block;

}


.submenu .nav-link {

    padding-left: 40px;

    font-size: 14px;

}


/* =========================
   FLECHA SUBMENU
========================= */

.menu-toggle .bi-chevron-down {

    float: right;

    transition: transform 0.3s ease;

}


.menu-toggle.open .bi-chevron-down {

    transform: rotate(180deg);

}


/* =========================
   CONTENIDO
========================= */

.content {

    margin-left: 280px;

    padding: 30px;

    transition: all 0.3s ease;

    min-height: 100vh;

}


/* =========================
   TOPBAR
========================= */

.topbar {

    background: white;

    padding: 18px 25px;

    border-radius: 15px;

    box-shadow:
        0 3px 10px rgba(0,0,0,0.05);

    margin-bottom: 25px;

}


/* =====================================================
   BOTÓN MENU RESPONSIVE
===================================================== */

.btn-menu {

    display: none;

    position: fixed;

    top: 20px;

    left: 20px;

    width: 52px;

    height: 52px;

    border: none;

    border-radius: 14px;

    background: #0ea5e9;

    color: white;

    font-size: 27px;

    align-items: center;

    justify-content: center;

    cursor: pointer;

    z-index: 1100;

    box-shadow:
        0 6px 18px rgba(0,0,0,0.20);

    transition:
        transform 0.2s ease,
        background 0.2s ease,
        box-shadow 0.2s ease;

}


/* =========================
   HOVER BOTÓN
========================= */

.btn-menu:hover {

    background: #0284c7;

    transform: translateY(-2px);

    box-shadow:
        0 8px 22px rgba(0,0,0,0.25);

}


/* =========================
   CLICK BOTÓN
========================= */

.btn-menu:active {

    transform: scale(0.94);

}


/* =========================
   ICONO BOTÓN
========================= */

.btn-menu i {

    margin: 0;

    line-height: 1;

}


/* =========================
   BIENVENIDA
========================= */

.welcome {

    background: linear-gradient(
        135deg,
        #0ea5e9,
        #2563eb
    );

    color: white;

    border-radius: 18px;

    padding: 30px;

    margin-bottom: 30px;

}


/* =========================
   TARJETAS
========================= */

.dashboard-card {

    border: none;

    border-radius: 15px;

    transition: 0.3s;

    box-shadow:
        0 4px 12px rgba(0,0,0,0.05);

    height: 100%;

}


.dashboard-card:hover {

    transform: translateY(-5px);

    box-shadow:
        0 10px 20px rgba(0,0,0,0.10);

}


/* =========================
   ICONOS CARDS
========================= */

.icon-box {

    width: 60px;

    height: 60px;

    min-width: 60px;

    border-radius: 15px;

    display: flex;

    align-items: center;

    justify-content: center;

    font-size: 25px;

}


.blue {

    background: #dbeafe;

    color: #2563eb;

}


.green {

    background: #dcfce7;

    color: #16a34a;

}


.red {

    background: #fee2e2;

    color: #dc2626;

}


.orange {

    background: #ffedd5;

    color: #ea580c;

}


/* =========================
   OVERLAY MOVIL
========================= */

.overlay {

    display: none;

    position: fixed;

    top: 0;

    left: 0;

    width: 100%;

    height: 100%;

    background: rgba(0,0,0,0.5);

    z-index: 1040;

}


.overlay.show {

    display: block;

}


/* =====================================================
   RESPONSIVE TABLET / MOVIL
===================================================== */

@media (max-width: 991px) {


    /* =========================
       SIDEBAR RESPONSIVE
    ========================== */

    .sidebar {

        left: -280px;

        width: 280px;

        height: 100vh;

        min-height: 100vh;

        max-height: 100vh;

        overflow-y: auto;

        overflow-x: hidden;

        box-shadow:
            5px 0 20px rgba(0,0,0,0.25);

    }


    /* =========================
       SIDEBAR ABIERTO
    ========================== */

    .sidebar.show {

        left: 0;

    }


    /* =========================
       CONTENIDO
    ========================== */

    .content {

        margin-left: 0;

        padding: 20px;

    }


    /* =========================
       BOTÓN MENU
    ========================== */

    .btn-menu {

        display: flex;

    }

}


/* =====================================================
   CELULARES
===================================================== */

@media (max-width: 576px) {


    /* =========================
       SIDEBAR
    ========================== */

    .sidebar {

        width: 280px;

        height: 100vh;

        min-height: 100vh;

        max-height: 100vh;

        overflow-y: auto;

        overflow-x: hidden;

    }


    /* =========================
       CONTENIDO
    ========================== */

    .content {

        padding: 15px;

    }


    /* =========================
       TOPBAR
    ========================== */

    .topbar {

        padding: 15px;

        padding-top: 70px;

    }


    .topbar h4 {

        font-size: 18px;

    }


    /* =========================
       BOTÓN MENU
    ========================== */

    .btn-menu {

        top: 15px;

        left: 15px;

        width: 48px;

        height: 48px;

        border-radius: 13px;

        font-size: 25px;

    }


    /* =========================
       BIENVENIDA
    ========================== */

    .welcome {

        padding: 20px;

        text-align: center;

    }


    .welcome h2 {

        font-size: 22px;

    }


    .welcome p {

        font-size: 14px;

    }


    .welcome i {

        font-size: 55px !important;

        margin-top: 15px;

    }


    /* =========================
       CARDS
    ========================== */

    .dashboard-card h3 {

        font-size: 20px;

    }


    .icon-box {

        width: 50px;

        height: 50px;

        min-width: 50px;

        font-size: 20px;

    }


    /* =========================
       LOGO
    ========================== */

    .logo h4 {

        font-size: 20px;

    }

}


/* =====================================================
   CELULARES MUY PEQUEÑOS
===================================================== */

@media (max-width: 380px) {


    /* =========================
       SIDEBAR
    ========================== */

    .sidebar {

        width: 275px;

        height: 100vh;

        min-height: 100vh;

        max-height: 100vh;

        overflow-y: auto;

        overflow-x: hidden;

    }


    /* =========================
       BOTÓN MENU
    ========================== */

    .btn-menu {

        width: 45px;

        height: 45px;

        top: 12px;

        left: 12px;

        font-size: 23px;

    }


    /* =========================
       TOPBAR
    ========================== */

    .topbar {

        padding-top: 65px;

    }

}
`, "",{"version":3,"sources":["webpack://./css/style.css"],"names":[],"mappings":";AACA;;2BAE2B;;AAE3B;;IAEI,SAAS;;IAET,UAAU;;IAEV,sBAAsB;;AAE1B;;;AAGA;;IAEI,mBAAmB;;IAEnB,8BAA8B;;IAE9B,kBAAkB;;AAEtB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,YAAY;;IAEZ,aAAa;;IAEb,iBAAiB;;IAEjB,iBAAiB;;IAEjB;;;;KAIC;;IAED,eAAe;;IAEf,MAAM;;IAEN,OAAO;;IAEP,aAAa;;IAEb,YAAY;;IAEZ,aAAa;;IAEb;;gCAE4B;;IAE5B,gBAAgB;;IAEhB,kBAAkB;;IAElB;;gCAE4B;;IAE5B,qBAAqB;;IAErB;;eAEW;;IAEX,yBAAyB;;AAE7B;;;AAGA;;2BAE2B;;AAE3B;;IAEI,UAAU;;AAEd;;;AAGA;;IAEI,mBAAmB;;AAEvB;;;AAGA;;IAEI,mBAAmB;;IAEnB,mBAAmB;;AAEvB;;;AAGA;;IAEI,mBAAmB;;AAEvB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,kBAAkB;;IAElB,aAAa;;IAEb,gCAAgC;;IAEhC,mBAAmB;;AAEvB;;;AAGA;;IAEI,eAAe;;IAEf,cAAc;;AAElB;;;AAGA;;IAEI,eAAe;;IAEf,iBAAiB;;AAErB;;;AAGA;;IAEI,cAAc;;AAElB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,eAAe;;IAEf,cAAc;;IAEd,sBAAsB;;IAEtB,yBAAyB;;IAEzB,iBAAiB;;AAErB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,cAAc;;IAEd,kBAAkB;;IAElB,kBAAkB;;IAElB,kBAAkB;;IAElB,oBAAoB;;IAEpB,mBAAmB;;IAEnB,eAAe;;AAEnB;;;AAGA;;IAEI,mBAAmB;;IAEnB,YAAY;;AAEhB;;;AAGA;;IAEI,mBAAmB;;IAEnB,YAAY;;AAEhB;;;AAGA;;IAEI,kBAAkB;;AAEtB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,kCAAkC;;IAElC,kBAAkB;;IAElB,kBAAkB;;IAElB,gBAAgB;;AAEpB;;;AAGA;;IAEI,cAAc;;AAElB;;;AAGA;;IAEI,kBAAkB;;IAElB,eAAe;;AAEnB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,YAAY;;IAEZ,+BAA+B;;AAEnC;;;AAGA;;IAEI,yBAAyB;;AAE7B;;;AAGA;;2BAE2B;;AAE3B;;IAEI,kBAAkB;;IAElB,aAAa;;IAEb,yBAAyB;;IAEzB,iBAAiB;;AAErB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,iBAAiB;;IAEjB,kBAAkB;;IAElB,mBAAmB;;IAEnB;mCAC+B;;IAE/B,mBAAmB;;AAEvB;;;AAGA;;uDAEuD;;AAEvD;;IAEI,aAAa;;IAEb,eAAe;;IAEf,SAAS;;IAET,UAAU;;IAEV,WAAW;;IAEX,YAAY;;IAEZ,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;;IAEnB,uBAAuB;;IAEvB,eAAe;;IAEf,aAAa;;IAEb;mCAC+B;;IAE/B;;;4BAGwB;;AAE5B;;;AAGA;;2BAE2B;;AAE3B;;IAEI,mBAAmB;;IAEnB,2BAA2B;;IAE3B;mCAC+B;;AAEnC;;;AAGA;;2BAE2B;;AAE3B;;IAEI,sBAAsB;;AAE1B;;;AAGA;;2BAE2B;;AAE3B;;IAEI,SAAS;;IAET,cAAc;;AAElB;;;AAGA;;2BAE2B;;AAE3B;;IAEI;;;;KAIC;;IAED,YAAY;;IAEZ,mBAAmB;;IAEnB,aAAa;;IAEb,mBAAmB;;AAEvB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,YAAY;;IAEZ,mBAAmB;;IAEnB,gBAAgB;;IAEhB;mCAC+B;;IAE/B,YAAY;;AAEhB;;;AAGA;;IAEI,2BAA2B;;IAE3B;oCACgC;;AAEpC;;;AAGA;;2BAE2B;;AAE3B;;IAEI,WAAW;;IAEX,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;;IAEnB,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,eAAe;;AAEnB;;;AAGA;;IAEI,mBAAmB;;IAEnB,cAAc;;AAElB;;;AAGA;;IAEI,mBAAmB;;IAEnB,cAAc;;AAElB;;;AAGA;;IAEI,mBAAmB;;IAEnB,cAAc;;AAElB;;;AAGA;;IAEI,mBAAmB;;IAEnB,cAAc;;AAElB;;;AAGA;;2BAE2B;;AAE3B;;IAEI,aAAa;;IAEb,eAAe;;IAEf,MAAM;;IAEN,OAAO;;IAEP,WAAW;;IAEX,YAAY;;IAEZ,2BAA2B;;IAE3B,aAAa;;AAEjB;;;AAGA;;IAEI,cAAc;;AAElB;;;AAGA;;uDAEuD;;AAEvD;;;IAGI;;gCAE4B;;IAE5B;;QAEI,YAAY;;QAEZ,YAAY;;QAEZ,aAAa;;QAEb,iBAAiB;;QAEjB,iBAAiB;;QAEjB,gBAAgB;;QAEhB,kBAAkB;;QAElB;uCAC+B;;IAEnC;;;IAGA;;gCAE4B;;IAE5B;;QAEI,OAAO;;IAEX;;;IAGA;;gCAE4B;;IAE5B;;QAEI,cAAc;;QAEd,aAAa;;IAEjB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,aAAa;;IAEjB;;AAEJ;;;AAGA;;uDAEuD;;AAEvD;;;IAGI;;gCAE4B;;IAE5B;;QAEI,YAAY;;QAEZ,aAAa;;QAEb,iBAAiB;;QAEjB,iBAAiB;;QAEjB,gBAAgB;;QAEhB,kBAAkB;;IAEtB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,aAAa;;IAEjB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,aAAa;;QAEb,iBAAiB;;IAErB;;;IAGA;;QAEI,eAAe;;IAEnB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,SAAS;;QAET,UAAU;;QAEV,WAAW;;QAEX,YAAY;;QAEZ,mBAAmB;;QAEnB,eAAe;;IAEnB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,aAAa;;QAEb,kBAAkB;;IAEtB;;;IAGA;;QAEI,eAAe;;IAEnB;;;IAGA;;QAEI,eAAe;;IAEnB;;;IAGA;;QAEI,0BAA0B;;QAE1B,gBAAgB;;IAEpB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,eAAe;;IAEnB;;;IAGA;;QAEI,WAAW;;QAEX,YAAY;;QAEZ,eAAe;;QAEf,eAAe;;IAEnB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,eAAe;;IAEnB;;AAEJ;;;AAGA;;uDAEuD;;AAEvD;;;IAGI;;gCAE4B;;IAE5B;;QAEI,YAAY;;QAEZ,aAAa;;QAEb,iBAAiB;;QAEjB,iBAAiB;;QAEjB,gBAAgB;;QAEhB,kBAAkB;;IAEtB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,WAAW;;QAEX,YAAY;;QAEZ,SAAS;;QAET,UAAU;;QAEV,eAAe;;IAEnB;;;IAGA;;gCAE4B;;IAE5B;;QAEI,iBAAiB;;IAErB;;AAEJ","sourcesContent":["\r\n/* =========================\r\n   CONFIGURACIÓN GENERAL\r\n========================= */\r\n\r\n* {\r\n\r\n    margin: 0;\r\n\r\n    padding: 0;\r\n\r\n    box-sizing: border-box;\r\n\r\n}\r\n\r\n\r\nbody {\r\n\r\n    background: #f4f6f9;\r\n\r\n    font-family: Arial, sans-serif;\r\n\r\n    overflow-x: hidden;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   SIDEBAR\r\n========================= */\r\n\r\n.sidebar {\r\n\r\n    width: 280px;\r\n\r\n    height: 100vh;\r\n\r\n    min-height: 100vh;\r\n\r\n    max-height: 100vh;\r\n\r\n    background: linear-gradient(\r\n        180deg,\r\n        #1f2937,\r\n        #111827\r\n    );\r\n\r\n    position: fixed;\r\n\r\n    top: 0;\r\n\r\n    left: 0;\r\n\r\n    z-index: 1050;\r\n\r\n    color: white;\r\n\r\n    padding: 20px;\r\n\r\n    /* =========================\r\n       SCROLL VERTICAL\r\n    ========================== */\r\n\r\n    overflow-y: auto;\r\n\r\n    overflow-x: hidden;\r\n\r\n    /* =========================\r\n       SCROLLBAR\r\n    ========================== */\r\n\r\n    scrollbar-width: thin;\r\n\r\n    scrollbar-color:\r\n        #4b5563\r\n        #111827;\r\n\r\n    transition: all 0.3s ease;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   SCROLLBAR CHROME / EDGE\r\n========================= */\r\n\r\n.sidebar::-webkit-scrollbar {\r\n\r\n    width: 7px;\r\n\r\n}\r\n\r\n\r\n.sidebar::-webkit-scrollbar-track {\r\n\r\n    background: #111827;\r\n\r\n}\r\n\r\n\r\n.sidebar::-webkit-scrollbar-thumb {\r\n\r\n    background: #4b5563;\r\n\r\n    border-radius: 10px;\r\n\r\n}\r\n\r\n\r\n.sidebar::-webkit-scrollbar-thumb:hover {\r\n\r\n    background: #6b7280;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   LOGO\r\n========================= */\r\n\r\n.logo {\r\n\r\n    text-align: center;\r\n\r\n    padding: 15px;\r\n\r\n    border-bottom: 1px solid #374151;\r\n\r\n    margin-bottom: 15px;\r\n\r\n}\r\n\r\n\r\n.logo i {\r\n\r\n    font-size: 42px;\r\n\r\n    color: #38bdf8;\r\n\r\n}\r\n\r\n\r\n.logo h4 {\r\n\r\n    margin-top: 8px;\r\n\r\n    font-weight: bold;\r\n\r\n}\r\n\r\n\r\n.logo small {\r\n\r\n    color: #9ca3af;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   TITULOS MENU\r\n========================= */\r\n\r\n.menu-title {\r\n\r\n    font-size: 11px;\r\n\r\n    color: #9ca3af;\r\n\r\n    margin: 20px 10px 10px;\r\n\r\n    text-transform: uppercase;\r\n\r\n    font-weight: bold;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   LINKS SIDEBAR\r\n========================= */\r\n\r\n.sidebar .nav-link {\r\n\r\n    color: #d1d5db;\r\n\r\n    padding: 12px 15px;\r\n\r\n    margin-bottom: 5px;\r\n\r\n    border-radius: 8px;\r\n\r\n    transition: all 0.3s;\r\n\r\n    white-space: nowrap;\r\n\r\n    cursor: pointer;\r\n\r\n}\r\n\r\n\r\n.sidebar .nav-link:hover {\r\n\r\n    background: #374151;\r\n\r\n    color: white;\r\n\r\n}\r\n\r\n\r\n.sidebar .nav-link.active {\r\n\r\n    background: #0ea5e9;\r\n\r\n    color: white;\r\n\r\n}\r\n\r\n\r\n.sidebar .nav-link i {\r\n\r\n    margin-right: 10px;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   SUBMENUS\r\n========================= */\r\n\r\n.submenu {\r\n\r\n    display: none;\r\n\r\n    background: rgba(255,255,255,0.05);\r\n\r\n    border-radius: 8px;\r\n\r\n    margin-bottom: 8px;\r\n\r\n    overflow: hidden;\r\n\r\n}\r\n\r\n\r\n.submenu.show {\r\n\r\n    display: block;\r\n\r\n}\r\n\r\n\r\n.submenu .nav-link {\r\n\r\n    padding-left: 40px;\r\n\r\n    font-size: 14px;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   FLECHA SUBMENU\r\n========================= */\r\n\r\n.menu-toggle .bi-chevron-down {\r\n\r\n    float: right;\r\n\r\n    transition: transform 0.3s ease;\r\n\r\n}\r\n\r\n\r\n.menu-toggle.open .bi-chevron-down {\r\n\r\n    transform: rotate(180deg);\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   CONTENIDO\r\n========================= */\r\n\r\n.content {\r\n\r\n    margin-left: 280px;\r\n\r\n    padding: 30px;\r\n\r\n    transition: all 0.3s ease;\r\n\r\n    min-height: 100vh;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   TOPBAR\r\n========================= */\r\n\r\n.topbar {\r\n\r\n    background: white;\r\n\r\n    padding: 18px 25px;\r\n\r\n    border-radius: 15px;\r\n\r\n    box-shadow:\r\n        0 3px 10px rgba(0,0,0,0.05);\r\n\r\n    margin-bottom: 25px;\r\n\r\n}\r\n\r\n\r\n/* =====================================================\r\n   BOTÓN MENU RESPONSIVE\r\n===================================================== */\r\n\r\n.btn-menu {\r\n\r\n    display: none;\r\n\r\n    position: fixed;\r\n\r\n    top: 20px;\r\n\r\n    left: 20px;\r\n\r\n    width: 52px;\r\n\r\n    height: 52px;\r\n\r\n    border: none;\r\n\r\n    border-radius: 14px;\r\n\r\n    background: #0ea5e9;\r\n\r\n    color: white;\r\n\r\n    font-size: 27px;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: center;\r\n\r\n    cursor: pointer;\r\n\r\n    z-index: 1100;\r\n\r\n    box-shadow:\r\n        0 6px 18px rgba(0,0,0,0.20);\r\n\r\n    transition:\r\n        transform 0.2s ease,\r\n        background 0.2s ease,\r\n        box-shadow 0.2s ease;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   HOVER BOTÓN\r\n========================= */\r\n\r\n.btn-menu:hover {\r\n\r\n    background: #0284c7;\r\n\r\n    transform: translateY(-2px);\r\n\r\n    box-shadow:\r\n        0 8px 22px rgba(0,0,0,0.25);\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   CLICK BOTÓN\r\n========================= */\r\n\r\n.btn-menu:active {\r\n\r\n    transform: scale(0.94);\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   ICONO BOTÓN\r\n========================= */\r\n\r\n.btn-menu i {\r\n\r\n    margin: 0;\r\n\r\n    line-height: 1;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   BIENVENIDA\r\n========================= */\r\n\r\n.welcome {\r\n\r\n    background: linear-gradient(\r\n        135deg,\r\n        #0ea5e9,\r\n        #2563eb\r\n    );\r\n\r\n    color: white;\r\n\r\n    border-radius: 18px;\r\n\r\n    padding: 30px;\r\n\r\n    margin-bottom: 30px;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   TARJETAS\r\n========================= */\r\n\r\n.dashboard-card {\r\n\r\n    border: none;\r\n\r\n    border-radius: 15px;\r\n\r\n    transition: 0.3s;\r\n\r\n    box-shadow:\r\n        0 4px 12px rgba(0,0,0,0.05);\r\n\r\n    height: 100%;\r\n\r\n}\r\n\r\n\r\n.dashboard-card:hover {\r\n\r\n    transform: translateY(-5px);\r\n\r\n    box-shadow:\r\n        0 10px 20px rgba(0,0,0,0.10);\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   ICONOS CARDS\r\n========================= */\r\n\r\n.icon-box {\r\n\r\n    width: 60px;\r\n\r\n    height: 60px;\r\n\r\n    min-width: 60px;\r\n\r\n    border-radius: 15px;\r\n\r\n    display: flex;\r\n\r\n    align-items: center;\r\n\r\n    justify-content: center;\r\n\r\n    font-size: 25px;\r\n\r\n}\r\n\r\n\r\n.blue {\r\n\r\n    background: #dbeafe;\r\n\r\n    color: #2563eb;\r\n\r\n}\r\n\r\n\r\n.green {\r\n\r\n    background: #dcfce7;\r\n\r\n    color: #16a34a;\r\n\r\n}\r\n\r\n\r\n.red {\r\n\r\n    background: #fee2e2;\r\n\r\n    color: #dc2626;\r\n\r\n}\r\n\r\n\r\n.orange {\r\n\r\n    background: #ffedd5;\r\n\r\n    color: #ea580c;\r\n\r\n}\r\n\r\n\r\n/* =========================\r\n   OVERLAY MOVIL\r\n========================= */\r\n\r\n.overlay {\r\n\r\n    display: none;\r\n\r\n    position: fixed;\r\n\r\n    top: 0;\r\n\r\n    left: 0;\r\n\r\n    width: 100%;\r\n\r\n    height: 100%;\r\n\r\n    background: rgba(0,0,0,0.5);\r\n\r\n    z-index: 1040;\r\n\r\n}\r\n\r\n\r\n.overlay.show {\r\n\r\n    display: block;\r\n\r\n}\r\n\r\n\r\n/* =====================================================\r\n   RESPONSIVE TABLET / MOVIL\r\n===================================================== */\r\n\r\n@media (max-width: 991px) {\r\n\r\n\r\n    /* =========================\r\n       SIDEBAR RESPONSIVE\r\n    ========================== */\r\n\r\n    .sidebar {\r\n\r\n        left: -280px;\r\n\r\n        width: 280px;\r\n\r\n        height: 100vh;\r\n\r\n        min-height: 100vh;\r\n\r\n        max-height: 100vh;\r\n\r\n        overflow-y: auto;\r\n\r\n        overflow-x: hidden;\r\n\r\n        box-shadow:\r\n            5px 0 20px rgba(0,0,0,0.25);\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       SIDEBAR ABIERTO\r\n    ========================== */\r\n\r\n    .sidebar.show {\r\n\r\n        left: 0;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       CONTENIDO\r\n    ========================== */\r\n\r\n    .content {\r\n\r\n        margin-left: 0;\r\n\r\n        padding: 20px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       BOTÓN MENU\r\n    ========================== */\r\n\r\n    .btn-menu {\r\n\r\n        display: flex;\r\n\r\n    }\r\n\r\n}\r\n\r\n\r\n/* =====================================================\r\n   CELULARES\r\n===================================================== */\r\n\r\n@media (max-width: 576px) {\r\n\r\n\r\n    /* =========================\r\n       SIDEBAR\r\n    ========================== */\r\n\r\n    .sidebar {\r\n\r\n        width: 280px;\r\n\r\n        height: 100vh;\r\n\r\n        min-height: 100vh;\r\n\r\n        max-height: 100vh;\r\n\r\n        overflow-y: auto;\r\n\r\n        overflow-x: hidden;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       CONTENIDO\r\n    ========================== */\r\n\r\n    .content {\r\n\r\n        padding: 15px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       TOPBAR\r\n    ========================== */\r\n\r\n    .topbar {\r\n\r\n        padding: 15px;\r\n\r\n        padding-top: 70px;\r\n\r\n    }\r\n\r\n\r\n    .topbar h4 {\r\n\r\n        font-size: 18px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       BOTÓN MENU\r\n    ========================== */\r\n\r\n    .btn-menu {\r\n\r\n        top: 15px;\r\n\r\n        left: 15px;\r\n\r\n        width: 48px;\r\n\r\n        height: 48px;\r\n\r\n        border-radius: 13px;\r\n\r\n        font-size: 25px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       BIENVENIDA\r\n    ========================== */\r\n\r\n    .welcome {\r\n\r\n        padding: 20px;\r\n\r\n        text-align: center;\r\n\r\n    }\r\n\r\n\r\n    .welcome h2 {\r\n\r\n        font-size: 22px;\r\n\r\n    }\r\n\r\n\r\n    .welcome p {\r\n\r\n        font-size: 14px;\r\n\r\n    }\r\n\r\n\r\n    .welcome i {\r\n\r\n        font-size: 55px !important;\r\n\r\n        margin-top: 15px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       CARDS\r\n    ========================== */\r\n\r\n    .dashboard-card h3 {\r\n\r\n        font-size: 20px;\r\n\r\n    }\r\n\r\n\r\n    .icon-box {\r\n\r\n        width: 50px;\r\n\r\n        height: 50px;\r\n\r\n        min-width: 50px;\r\n\r\n        font-size: 20px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       LOGO\r\n    ========================== */\r\n\r\n    .logo h4 {\r\n\r\n        font-size: 20px;\r\n\r\n    }\r\n\r\n}\r\n\r\n\r\n/* =====================================================\r\n   CELULARES MUY PEQUEÑOS\r\n===================================================== */\r\n\r\n@media (max-width: 380px) {\r\n\r\n\r\n    /* =========================\r\n       SIDEBAR\r\n    ========================== */\r\n\r\n    .sidebar {\r\n\r\n        width: 275px;\r\n\r\n        height: 100vh;\r\n\r\n        min-height: 100vh;\r\n\r\n        max-height: 100vh;\r\n\r\n        overflow-y: auto;\r\n\r\n        overflow-x: hidden;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       BOTÓN MENU\r\n    ========================== */\r\n\r\n    .btn-menu {\r\n\r\n        width: 45px;\r\n\r\n        height: 45px;\r\n\r\n        top: 12px;\r\n\r\n        left: 12px;\r\n\r\n        font-size: 23px;\r\n\r\n    }\r\n\r\n\r\n    /* =========================\r\n       TOPBAR\r\n    ========================== */\r\n\r\n    .topbar {\r\n\r\n        padding-top: 65px;\r\n\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
